module.exports = __webpack_public_path__ + "img/leaf.5db673b4.png";